module.exports = __webpack_public_path__ + "img/762009070855346_image.jpg";